export { default as GlossaryList } from './glossaryList';
export { glossaryListType } from './glossaryList.types';
export { glossaryListStandard } from './__fixtures__/glossaryList';
